/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
import { NzConfigKey } from 'ng-zorro-antd/core/config';

export const FADE_CLASS_NAME_MAP = {
  enter: 'fade-enter',
  enterActive: 'fade-enter-active',
  leave: 'fade-leave',
  leaveActive: 'fade-leave-active'
};

export const IMAGE_PREVIEW_MASK_CLASS_NAME = 'ant-image-preview-mask';
export const NZ_CONFIG_MODULE_NAME: NzConfigKey = 'image';
